import { Badge, Tooltip } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

export const WorkflowNodeCard = ({
  children,
  className,
  label,
  iconCard,
  name,
  groupBadge,
}: {
  children: React.ReactNode;
  className?: string;
  label: string;
  iconCard: {
    bgClassName: string;
    icon: React.ReactNode;
  };
  name: string;
  groupBadge?: {
    groupId: string;
    name: string;
    position: number;
  };
}) => {
  return (
    <div className={cn('min-w-[180px] px-2 py-2 pr-5 rounded-md border bg-white', className)}>
      <div className="text-xs flex gap-2">
        <div>
          <div className={`p-2 ${iconCard.bgClassName} rounded-md`}>
            {iconCard.icon}
          </div>
        </div>
        <div className="flex flex-col relative flex-1">
          {groupBadge && (
            <Tooltip content={`Group - ${groupBadge.name} #${groupBadge.position}`}>
              <Badge variant="gray" size="sm" className="absolute top-0 right-0 max-w-[200px] overflow-hidden [&>span]:truncate [&>span]:shrink">
                Group - {groupBadge.name} #{groupBadge.position}
              </Badge>
            </Tooltip>
          )}
          <div>
            <div className="flex items-center gap-2">
              <span className="txt-extra-small-regular">{label}</span>
            </div>
            <span className="txt-medium-medium">{name}</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
};
